import React, { useState, useRef } from 'react';
import { Input, Icon } from 'antd';
import 'antd/dist/antd.css';

import _validator from '../../modules/validator';
// Phase C.5 (Candidate System UI Language Migration): moved this control's own hardcoded
// English+Marathi fallback validation message onto the centralized Text/dictionary.js architecture.
import { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';

const BoxInput = (props) => {
    const inputRefs = useRef([]);

    const makeBlankArrayBoxInput = (string) => {
        let stringArray = string.split('');

        let array = [];
        for (let i = 0; i < props.boxInputNumberCount; i++) {
            let value = stringArray[i] || ""; // Use empty string if index is out of range
            let hasError = string !== "" && value === "";
            array.push({
                index: i + 1,
                value: value,
                hasError:  hasError
            });
        }
        return array;
    };

    const [boxInputArray, setBoxInputArray] = useState(makeBlankArrayBoxInput(props.boxInputValue));

    const handleOnChangeBoxInput = (e, index) => {
        let value = _validator.isAlphanumeric(e.target.value)
        if(value){
            const newArray = [...boxInputArray];
            newArray[index - 1] = {
                ...newArray[index - 1],
                value: e.target.value,
                hasError: e.target.value === ""
            };
            setBoxInputArray(newArray);

            if(newArray[index-1].value !== ""){
                const nextIndex = index + 1;
                if (inputRefs.current[nextIndex]) {
                    inputRefs.current[nextIndex].focus();
                }
            }

            let valueArray = [];
            for(let i = 0;newArray.length > i;i++){
                let obj = newArray[i];
                if(obj && obj.value && obj.value !== ""){
                    valueArray.push(obj.value)
                }
            }
            // if(valueArray && valueArray.length === props.boxInputNumberCount){
                let string = valueArray.join("");
                props.onChange(string)
            // }
        }
    };

    return (
        <>
            {props.label && <div>{props.label}</div>}
            <div style={{ display: "flex" }}>
                {boxInputArray.map((item, index) => (
                    <Input
                        key={item.index}
                        value={item.value}
                        className={`boxInputClassName ${item.hasError || props.errorState !== "" ? 'has-error' : ''}`}
                        onChange={(e) => handleOnChangeBoxInput(e, item.index)}
                        maxLength={1}
                        minLength={1}
                        ref={el => inputRefs.current[item.index] = el}
                    />
                ))}
            </div>
            {/* Stage 3.6 (Enterprise Shared Component Stabilization): added the close-circle Icon
                to match MyInput.jsx/TextArea.jsx/DropdownList.jsx's shared validation-message
                convention. Message content/fallback text unchanged. */}
            {props.errorState && <>
                <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />
                    {props.errorMessage || resolveText('submitForm.transactionNumberDigitsError', getCurrentLocale(), getCurrentDisplayMode())}
                </label>
            </>}
        </>
    );
};

export default BoxInput;